var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenrant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 108.1885",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.8948,43.2479H34.7513c-7.1557,0-10.3449-2.8731-10.3449-9.3332,0-3.2034,0-12.939,23.7505-12.939H64.279L85.2549,0H48.1569C16.8113,0,.9137,11.4107.9137,33.9147.9137,54.508,12.297,64.942,34.7513,64.942H50.8948c10.961,0,12.3615,4.9847,12.3615,9.3334,0,3.3781,0,13.6619-21.5118,13.6619-7.0331,0-19.44-2.2681-25.3323-2.8715L0,103.8211c15.17,1.5018,28.7521,2.8686,41.545,2.8686,30.0662,0,45.21-9.4346,45.21-32.4143C86.755,53.6882,74.6887,43.2479,50.8948,43.2479Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.7256,62.7908c15.8213-4.7632,23.0645-19.68,23.0645-32.2653C149.79,10.557,138.1168,0,116.0292,0H96.8866L75.9109,20.9757h38.8928c7.0528,0,10.6308,3.4106,10.6308,10.1259,0,12.6513-10.6921,19.0655-31.7819,19.0655H89.5868l2.2725,3.4655,37.9436,53.6314.6606.9245H160l-2.5582-3.4981Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenrant);
export default __webpack_public_path__ + "static/media/screenrant.54b16175f404d43498a857844e750e39.svg";
export { ForwardRef as ReactComponent };